import Alpine from "alpinejs";

const pathname = window.location.pathname;

Alpine.data("fetch", (url) => ({
    init() {
        const element = this.$el;
        const target = this.$refs.target || element;
        if (!url) {
            element.remove();
        }
        fetch(url)
            .then((response) => {
                if (!response.ok || response.status >= 300) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                const markup = data
                    .filter((item) => item.href != pathname)
                    .map((item) => item.markup)
                    .slice(0, 2)
                    .join("");
                if (!markup) {
                    throw new Error("No Markup found");
                }
                target.innerHTML = markup;
            })
            .catch((e) => {
                console.error(e);
                element.remove();
            });
    },
}));
